import { Button, Divider, Tooltip, IconButton } from "@mui/material";
import {useState, useEffect} from "react";
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined';
import SendIcon from '@mui/icons-material/Send';
import { useClosePeriodMutation, useGetPeriodQuery, useGetYearMetricsSummaryQuery } from "../../../../../services/PaymentToolApi";
import MoneyFormatter from "../../../../../components/moneyFormatter";
import { createErrorMessage, getPeriodStatus, getPeriodStatusComp } from "../../../../../utils";
import ConfirmationModal from '../../../../../components/basicModalConfirmation';
import { useNotification } from '../../../../../context/NotificationContext';
import TransactionSummary from "../components/transactionSummary";
import SendPaymentsModal from "../components/SendPaymentsModal";
import { useLocation, useHistory } from 'react-router-dom';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';


const PaymentByPeriodsHeader = ({ selectedYear, selectedPeriod, setSendPaymentsModalIsOpen }) => {

  const { showNotification } = useNotification();
  
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const history = useHistory();

  
  const [initClosePeriod, { error: closePeriodError, isLoading: closePeriodIsLoading }] = useClosePeriodMutation();
  const { data: period, isLoading: periodIsLoading, isFetching: periodIsFetching, error: periodError } = useGetPeriodQuery({period: selectedPeriod});
  const [periodModalIsOpen, setPeriodModalIsOpen] = useState(false);
  
  useEffect(() => {
    searchParams.get("year"); //A: this is the index of the tab in the admin tools
    searchParams.set("period", selectedPeriod);
    history.push(`/dashboard/admintools?${searchParams.toString()}`);
  }, [history, selectedPeriod]);

  const TableHeaderInfo = {
    padding: '1em',
    margin: '0 0 1px 0',
    borderRadius: '1em 1em 0 0',
    backgroundColor: 'white',
    width: '100%',
    display: 'flex',
    flexWrap: 'wrap',
    flexDirection: 'row',
    alignItems: 'flex-end',
    justifyContent: 'space-between'
  }

  async function handleClosePeriod() {
    try {
      let res = await initClosePeriod({ period: selectedPeriod }).unwrap();
      console.log("close period response: ", res);
      showNotification('Period Closed Successfully!', 'success');
    } catch (e) {
      console.log("error closing period: ", e);
      showNotification(createErrorMessage(e), 'error');
    }
  }

  //api response example: 
  // {
  //   "id": ,
  //   "year": 2024,
  //   "startDate": "2024-01-22T00:00:00",
  //   "endDate": "2024-01-28T23:59:59.997",
  //   "isCompleted": false
  // }

  console.log("period: selectedPeriod: ", selectedPeriod);
  console.log("period: periodError, ", JSON.stringify(periodError) );
  console.log("period: period " , period)

  if (periodIsLoading || periodIsFetching) return <p>Loading...</p>;
  if (periodError) return <p>Error! {JSON.stringify(periodError)}</p>;

  if(!period) return <p>Loading ...</p>;

  function onPaymentInformationClick(){
    let periodID = period.id;
    history.push(`/dashboard/admintools?tab_index=4&showPeriodPaymentInformation=${periodID}`);
  }

  return (
    <div>
    <div style={TableHeaderInfo} >
      <div style={{ margin: '0 1em 0 0' }} >

        <div style={{ display: 'flex', flexWrap: 'nowrap', margin: '0 0 0.5em 0' }} >
          <p style={{ fontWeight: '600', margin: '0 0.5em 0 0', whiteSpace: 'nowrap' }} >Displayed Period:</p>
          <p style={{ whiteSpace: 'nowrap' }} >{selectedPeriod}</p>
        </div>

        <div style={{ display: 'flex', flexWrap: 'nowrap' }} >
          <p style={{ fontWeight: '600', margin: '0 0.5em 0 0', whiteSpace: 'nowrap' }} >Status:</p>
          <p style={{ whiteSpace: 'nowrap', fontWeight: '600', }} >{getPeriodStatusComp(period)}</p>
          {/* Status can be 'Current', 'Pending', or 'Completed' */}
        </div>

      </div>

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }} >

        <div style={{ display: 'flex', flexWrap: 'nowrap', margin: '0 0 0.5em 0' }} >          
          {
            // //A: if period is current, the admin can not complete the period
            getPeriodStatus(period) != 'CURRENT' &&
            <>
              <Button disabled={ period.isCompleted } onClick={()=> setPeriodModalIsOpen(true)} variant="contained" size="small" startIcon={<CheckOutlinedIcon />} sx={{ margin: '0 1em 0 0', height: '28px', padding:'0px 14px' }}>
                COMPLETE
              </Button>

              {/* The download button must be disable if the period is not completed by an Admin. */}
              {
                period.synchronizedWithPayPal ?
                <Tooltip title="View Payment Information" placement="top-start">
                  <IconButton color="primary" onClick={onPaymentInformationClick}>
                    <InfoOutlinedIcon />
                  </IconButton>
                </Tooltip>
                :
                <Tooltip title="Send payments to PayPal" placement="top-start">
                  {/* periods before 2024-05-13 (we use 19 because es the end Date) are disabled because were payed manually */}
                  <Button disabled={ !period.isCompleted || new Date(period.endDate) < new Date(2024, 4, 19) } variant='contained' sx={{ padding: 0, width: '28px', minWidth: '0px', height: '28px' }} onClick={ ()=> setSendPaymentsModalIsOpen(period.id) } >
                    <SendIcon fontSize="12px" />
                  </Button>
                </Tooltip>
              }
            </>
          }

          

        </div>

        <TransactionSummary selectedYear={selectedYear} selectedPeriod={selectedPeriod} />

      </div>


    </div>

      <ConfirmationModal
        title={"Are you sure you want to close these Period?"}
        onClick={handleClosePeriod}
        handleClose={() => {
          setPeriodModalIsOpen(false);
        }}
        open={periodModalIsOpen}
        cancelLabel="No"
        confirmLabel="Yes"
      />

    </div>
  );
}

export default PaymentByPeriodsHeader;